import interfaceToast from './interfaceToast-zh-CN';
let zhCN = {
  interfaceToast: interfaceToast,
  "common": {
    loading: "加载中...",
    "completed": "已完成",
    "incomplete": "未完成",
    "inProgress": "进行中",
    "notStarted": "未开始",
    toBeCompleted: "待完成",
    expired : "已过期",
    duration: "时长",
    minutes: "分钟",
    hours: "小时",
    submit: "提交",
    tips: "温馨提示",
    "noDataHint": "暂无相关数据",
    "man": "男",
    "woman": "女",
    "affiliatedOrganization": "所属组织",
    "role": "角色",
    "confirm": "确认",
    "normal": "正常",
    "mild": "轻度",
    "moderate": "中度",
    "severe": "重度",
    "crisis": "危机",
    "noPermissionTemporarily": "暂无权限",
    "nothing": "无",
    "0levelType": "正常",
    "1levelType": "心理轻微问题",
    "2levelType": "中度心理问题",
    "3levelType": "重度心理问题",
    "4levelType": "严重心理问题",
    topping: "置顶",
    all: "全部",
    launch: "展开"
  },
  audio: {
    "voiceHint1": "当前音量已达到最小值",
    "voiceHint2": "当前音量已达到最大值"
  },
  tab: {
    home: "首页",
    dynamic: "动态",
    my: "我的",
    notification: "消息",
  },
  "dialogHint": {},
}
export default zhCN;


// WEBPACK FOOTER //
// ./src/i18n/zh-CN.js